const initialState = {
  assets: [],
}

export default function (state = initialState, action) {
  switch (action.type) {
    case 'GET ASSETS':
      return {
        ...state,
        assets: action.payload,
      }
    default:
      return state
  }
}
